import { rand } from "../utils/utils";

const splashes = [
  "newyears",
  "valentines",
  ["stpatricks", "icarus_daylight"],
  "easter",
  "mothers",
  "fathers",
  "4thjuly",
  ["laborday", "laborday_bad"],
  "bday",
  "halloween",
  "thanksgiving",
  ["christmas", "christmas2"]
]

const aprilFools = [
  "april fools",
  "pirate",
  "dodgeball"
]

function getSplash(date = new Date()) {
  const month = date.getMonth();
  let forTheMonth = splashes[month] || rand(splashes);

  if (month === 3) {
    const day = date.getDate();
    if (day < 11) forTheMonth = aprilFools
  }
  if (Array.isArray(forTheMonth)) return `splash/${rand(forTheMonth)}.jpg`;
  else return `splash/${forTheMonth}.jpg`;
}

export default getSplash